<template>
    <PerfectScrollbar class="AllPwaMobile">

      <div class="AllSiteHeaderMenu">
        <div class="MenuAllSiteHeaderMenuDeposit">
          <div class="ChildSelectTab">
            <!-- <div class="TabChildSelectTab">
              <vs-radio  color="#BB86FC" v-model="radios1" vs-name="radios1" vs-value="rial">{{ $t('withdraw.currencyType.rial') }}</vs-radio>
            </div> -->
            
            <div class="TabChildSelectTab">
              <vs-radio  color="#BB86FC" v-model="radios1" vs-name="radios1" vs-value="dollar">{{ $t('withdraw.currencyType.dollar') }}</vs-radio>
            </div>
          </div>

          <p>
            {{ $t('withdraw.title') }}
          </p>
        </div>
      </div>

      <div class="withdraw-balance-summary withdraw-balance-card">
        <div class="dashboard-balance-heading">
          <h3 class="dashboard-balance-title">{{ $t('dashboard.availableBalance') }}</h3>
          <span v-if="hasDollarWallet && usdtRate > 0" class="dashboard-rate-pill">
            تتر {{ formatPrice(usdtRate) }} تومان
          </span>
        </div>
        <div v-if="visibleBalanceWallets.length" class="dashboard-wallet-list">
          <div v-for="(wallet, index) in visibleBalanceWallets" :key="index" class="dashboard-wallet-item">
            <div class="dashboard-wallet-main">
              <span class="dashboard-wallet-name">{{ wallet.currency_name || wallet.currency_code }}</span>
              <strong class="dashboard-wallet-amount">{{ formatCurrency(displayAvailableBalance(wallet)) }}</strong>
            </div>
            <small
              v-if="usdtRate > 0 && ['USD', 'USDT'].includes((wallet.currency_code || '').toUpperCase())"
              class="dashboard-wallet-conversion"
            >
              ارزش تقریبی: {{ formatTomanEquivalentFromUSDT(displayAvailableBalance(wallet)) }} تومان
            </small>
          </div>
        </div>
        <p v-else class="dashboard-wallet-empty">—</p>
        <WalletFundsBreakdown :wallets="walletBalances" :withdrawals="withdrawalRecords" />
      </div>

      <div class="GetDollarSelect">

        <div style="margin-top: 20px !important;" class="ShowSelectSearch">
            <div class="ShowSelectSearchMarginTop">
                <span @click="setMaxAmount">{{ $t('withdraw.amount.max') }}</span>

                
                <label v-if="radios1 == 'dollar'">{{ $t('withdraw.amount.label.dollar') }}</label>
                <label v-if="radios1 == 'rial'">{{ $t('withdraw.amount.label.rial') }}</label>
            </div>
          <input class="InputX" type="text" :placeholder="$t('withdraw.amount.placeholder')" v-model="moneyDollar">
        </div>

        <div style="margin-top: 20px !important" v-if="radios1 == 'dollar'" class="ShowSelectSearch">
          <div class="ShowSelectSearchMarginTop">
            <router-link to="/wallet-user" class="nav-item">
              <span>{{ $t('withdraw.destination.manageAccounts') }}</span>
            </router-link>

            <label>{{ $t('withdraw.destination.walletAddress') }}</label>
          </div>
          <multiselect v-if="radios1 == 'dollar'" :placeholder="$t('withdraw.destination.selectPlaceholder')" v-model="value2" :options="option2" label="name" track-by="name"></multiselect>
        </div>

        <div style="margin-top: 20px !important" v-if="radios1 == 'rial'" class="ShowSelectSearch">
          <div class="ShowSelectSearchMarginTop">
            <span>{{ $t('withdraw.destination.manageAccounts') }}</span>

            <label>{{ $t('withdraw.destination.cardNumber') }}</label>
          </div>
          <multiselect v-if="radios1 == 'rial'" :placeholder="$t('withdraw.destination.selectPlaceholder')" v-model="value1" :options="option1" label="name" track-by="name"></multiselect>
        </div>
      </div>

      <div v-if="radios1 == 'dollar'" class="GetLineBoxRadios1">
        <div class="LineGetLineBoxRadios1">
          <p>{{ $t('withdraw.limits.dollar.range') }}</p>

          <p>{{ $t('withdraw.limits.rangeLabel') }}</p>
        </div>

        <div class="LineGetLineBoxRadios1">
          <p>{{ formatWithdrawalAmount(withdrawalFeeAmount) }} ({{ formatFeePercent(withdrawalFeePercent) }}%)</p>

          <p>{{ $t('withdraw.limits.fee') }}</p>
        </div>

        <div class="LineGetLineBoxRadios1">
          <p>{{ formatWithdrawalAmount(requestedWithdrawalAmount) }}</p>

          <p>{{ $t('withdraw.limits.requestedAmount') }}</p>
        </div>

        <div class="LineGetLineBoxRadios1">
          <p>{{ formatWithdrawalAmount(totalWithdrawalAmount) }}</p>

          <p>{{ $t('withdraw.limits.finalAmount') }}</p>
        </div>

        <div class="LineGetLineBoxRadios1">
          <p>1 USD = 1 تتر TRC20</p>

          <p>{{ $t('withdraw.limits.conversionRate') }}</p>
        </div>


        <div class="LineGetLineBoxRadios1">
          <p v-if="moneyDollar != ''">{{moneyDollar}}</p>
          <p v-if="moneyDollar == ''">0</p>

          <p>{{ $t('withdraw.limits.tetherEquivalent') }}</p>
        </div>
      </div>

      <div v-if="radios1 == 'rial'" class="GetLineBoxRadios1">
        <div class="LineGetLineBoxRadios1">
          <p>{{ $t('withdraw.limits.rial.range') }}</p>

          <p>{{ $t('withdraw.limits.rangeLabel') }}</p>
        </div>

        <div class="LineGetLineBoxRadios1">
          <p>{{ formatWithdrawalAmount(withdrawalFeeAmount) }} ({{ formatFeePercent(withdrawalFeePercent) }}%)</p>

          <p>{{ $t('withdraw.limits.fee') }}</p>
        </div>

        <div class="LineGetLineBoxRadios1">
          <p>{{ formatWithdrawalAmount(requestedWithdrawalAmount) }}</p>

          <p>{{ $t('withdraw.limits.requestedAmount') }}</p>
        </div>

        <div class="LineGetLineBoxRadios1">
          <p>{{ formatWithdrawalAmount(totalWithdrawalAmount) }}</p>

          <p>{{ $t('withdraw.limits.finalAmount') }}</p>
        </div>

        <div class="LineGetLineBoxRadios1">
          <p>1 USD = {{formatPrice(usdtRate)}} تومان</p>

          <p>{{ $t('withdraw.limits.conversionRate') }}</p>
        </div>


        <div class="LineGetLineBoxRadios1">
          <p v-if="moneyDollar != ''">{{ formatTetherEquivalent(moneyDollar) }} USDT</p>
          <p v-if="moneyDollar == ''">0 USDT</p>

          <p>{{ $t('withdraw.limits.tetherEquivalent') }}</p>
        </div>
      </div>

      <div style="margin-top: 40px;" v-if="radios1 == 'dollar'">
        <div class="InformationSelectBotton">
            <p>{{ $t('withdraw.info.walletAddress') }}</p>
            <VsxIcon iconName="InfoCircle" :size="22" color="#BB86FC" type="linear" />
        </div>
      </div>

      <div style="margin-top: 40px;" v-if="radios1 == 'rial'">
        <div class="InformationSelectBotton">
            <p>{{ $t('withdraw.info.cardNumber') }}</p>
            <VsxIcon iconName="InfoCircle" :size="22" color="#BB86FC" type="linear" />
        </div>
      </div>

      <div @click="btnClickSend" style="margin-top: 40px;" class="ButtonShowSelectSearch">
        {{ $t('withdraw.confirm') }}
      </div>

    </PerfectScrollbar>
</template>
<script>
  import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
  import Multiselect from 'vue-multiselect';
  import axios from "@/axios";
  import {toast} from "vue3-toastify";
  import WalletFundsBreakdown from './WalletFundsBreakdown.vue';
  export default {
    name: 'withdrawUSer',
    components: {
      PerfectScrollbar,
      Multiselect,
      WalletFundsBreakdown,
    },
    data(){
      return{
        radios1:'dollar',
        moneyDollar: '',
        value: {},
        qrValue: 'dadepardazan',
        listResponse: [],
        options: [

        ],


        value1: {},
        option1: [

        ],

        cardNumber: '',
        bankName: '',
        bankImage: '',

        iban: '',
        cardHolderName: '',
        errorMessage: '',
        usdtRate: 0,
        withdrawalFeePercent: 0,
        usdtRateTimer: null,
        walletBalances: [],
        pendingWithdrawalBalances: {},
        withdrawalRecords: [],

        value2: {name: 'آدرس کیف پول مقصد را انتخاب کنید'},
        option2: [

        ],

        
        value3: {name: 'شماره کارت ثبت شده را انتخاب کنید'},
        option3: [

        ],
      }
    },
    computed: {
      visibleBalanceWallets() {
        return this.walletBalances.filter(wallet => (wallet.currency_code || '').toUpperCase() !== 'IRR');
      },
      hasDollarWallet() {
        return this.visibleBalanceWallets.some(wallet => ['USD', 'USDT'].includes((wallet.currency_code || '').toUpperCase()));
      },
      requestedWithdrawalAmount() {
        const amount = Number(String(this.moneyDollar || '').replace(/,/g, ''));
        return Number.isFinite(amount) && amount > 0 ? amount : 0;
      },
      withdrawalFeeAmount() {
        return Math.round((this.requestedWithdrawalAmount * this.withdrawalFeePercent / 100 + Number.EPSILON) * 1e8) / 1e8;
      },
      totalWithdrawalAmount() {
        return Math.round((this.requestedWithdrawalAmount + this.withdrawalFeeAmount + Number.EPSILON) * 1e8) / 1e8;
      }
    },
    methods:{
      formatNumber(num) {
        if (typeof num !== 'string') {
          num = String(num);
        }
        return num.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
      },
      clickPointer(){
        navigator.clipboard.writeText(this.qrValue);

      },
      nameWithLang ({name, language}) {
        return `${name} — [${language}]`
      },
      identifyBank() {
        const bin = this.cardNumber.substring(0, 6);
        const bankInfo = this.getBankInfo(bin);
        this.bankName = bankInfo.name;
        this.bankImage = bankInfo.image;
      },
      getBankName(bin) {
        const bankData = {
          "603799": "بانک ملی ایران",
          "621986": "بانک سامان",
          "610433": "بانک ملت",
          "589210": "بانک سپه",
          "627648": "بانک توسعه صادرات",
          "627961": "بانک صنعت و معدن",
          "603770": "بانک کشاورزی",
          "628023": "بانک مسکن",
          "627760": "پست بانک ایران",
          "502908": "بانک توسعه تعاون",
          "627412": "بانک اقتصاد نوین",
          "622106": "بانک پارسیان",
          "502229": "بانک پاسارگاد",
          "639599": "بانک قوامین",
          "627488": "بانک کارآفرین",
          "639346": "بانک سینا",
          "639607": "بانک سرمایه",
          "504706": "بانک شهر",
          "502938": "بانک دی",
          "603769": "بانک صادرات",
          "627353": "بانک تجارت",
          "589463": "بانک رفاه",
          "627381": "بانک انصار",
          "639370": "بانک مهر اقتصاد",
          "507677": "موسسه اعتباری نور",
          "628157": "موسسه اعتباری توسعه",
          "505801": "موسسه اعتباری کوثر",
          "606256": "موسسه اعتباری ملل (عسکریه)",
          "606373": "بانک قرض الحسنه مهرایرانیان"
        };

        const bankImages = {
          "603799": "path/to/melli_bank_image.png",
          "621986": "path/to/saman_bank_image.png",
          "610433": "path/to/mellat_bank_image.png",
          "589210": "path/to/sepeh_bank_image.png",

          "627648": "path/to/tosee_saderat_bank_image.png",

          "627961": "path/to/sanat_madan_bank_image.png",

          "603770": "path/to/keshavarzi_bank_image.png",
          "628023": "path/to/maskan_bank_image.png",
          "627760": "path/to/post_bank_image.png",

          "502908": "path/to/tosee_tavan_bank_image.png",

          "627412": "path/to/eghtesad_novin_bank_image.png",
          "622106": "path/to/parsyan_bank_image.png",
          "502229": "path/to/pasargad_bank_image.png",
          "639599": "path/to/qavamin_bank_image.png",
          "627488": "path/to/karaferin_bank_image.png",
          "639346": "path/to/sina_bank_image.png",
          "639607": "path/to/sarmaye_bank_image.png",
          "504706": "path/to/shahr_bank_image.png",
          "502938": "path/to/die_bank_image.png",
          "603769": "path/to/saderat_bank_image.png",
          "627353": "path/to/tejarat_bank_image.png",
          "589463": "path/to/refah_bank_image.png",
          "627381": "path/to/ansar_bank_image.png",
          "639370": "path/to/mehr_eghtesad_bank_image.png",

          "507677": "path/to/noor_bank_image.png",

          // 11111
          "628157": "path/to/tosee_bank_image.png",
          // 11111

          "505801": "path/to/kosar_bank_image.png",

          "606256": "path/to/sosase_etebari_askari.png",

          "606373": "path/to/bankgharzolhasane.png"
        };

        const bankName = bankData[bin] || "بانک ناشناخته";
        const bankImage = bankImages[bin] || "path/to/default_image.png"; // تصویر پیش‌فرض در صورت ناشناخته بودن

        return { name: bankName, image: bankImage };
      },
      async getWallet(){
        const userData = localStorage.getItem('user');
        const userData1 = JSON.parse(userData);

        let attempts = 0;
        const maxAttempts = 10;
        const delay = 100;
        while (attempts < maxAttempts) {
          try {
            const response = await axios.post('/get-wallet' , {
              user_id : userData1.id,
            });

            this.listResponse = response.data[0]

            this.siteBank = response.data[1]
            this.myBank = response.data[2];

            this.option1 = [];
            for (let i = 0; i < response.data[2].length; i++) {
              const account = response.data[2][i];
              this.option1.push({
                name: `${account.bank} | ${this.formatWalletBalance(account.balance)} IRR`,
                value: account.id,
                balance: account.balance,
              });
            }


            this.option2 = [];
            for (let i = 0; i < response.data[0].length; i++) {
              const wallet = response.data[0][i];
              this.option2.push({
                name: wallet.name,
                value: wallet.id,
                balance: wallet.balance,
              });
            }

            return;
          } catch (error) {
            console.log('error')
          }

          attempts++;
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      },
      formatPrice(value) {
        const numericValue = Number(String(value ?? '').replace(/,/g, ''));
        if (!Number.isFinite(numericValue)) return '0';
        return Math.round(numericValue).toLocaleString('en-US');
      },
      formatTetherEquivalent(rialAmount) {
        const amount = Number(String(rialAmount ?? '').replace(/,/g, ''));
        const rateInToman = Number(this.usdtRate);
        if (!Number.isFinite(amount) || !Number.isFinite(rateInToman) || amount <= 0 || rateInToman <= 0) {
          return '0';
        }

        // The entered amount is in rials; the live rate is in tomans per USDT.
        const tetherAmount = amount / 10 / rateInToman;
        return tetherAmount.toLocaleString('en-US', { maximumFractionDigits: 8 });
      },
      formatTomanEquivalentFromUSDT(usdtAmount) {
        const amount = Number(usdtAmount);
        const rateInToman = Number(this.usdtRate);
        if (!Number.isFinite(amount) || !Number.isFinite(rateInToman) || amount <= 0 || rateInToman <= 0) {
          return '0';
        }

        return Math.round(amount * rateInToman).toLocaleString('en-US');
      },
      formatCurrency(value) {
        const amount = Number(value);
        if (!Number.isFinite(amount)) return '$0.00';
        return `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      },
      formatExactCurrency(value) {
        const amount = Number(value);
        if (!Number.isFinite(amount)) return '$0.00';
        return `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 8 })}`;
      },
      formatWithdrawalAmount(value) {
        return this.radios1 === 'rial'
          ? `${this.formatPrice(value)} ریال`
          : `${this.formatExactCurrency(value)} USD`;
      },
      formatFeePercent(value) {
        const rate = Number(value);
        if (!Number.isFinite(rate) || rate < 0) return '0';
        return rate.toLocaleString('en-US', { maximumFractionDigits: 2 });
      },
      formatWalletBalance(value) {
        const numericValue = Number(value);
        if (!Number.isFinite(numericValue)) return '0';
        return numericValue.toLocaleString('en-US', { maximumFractionDigits: 8 });
      },
      formatWalletCurrency(currencyCode, value) {
        if ((currencyCode || '').toUpperCase() === 'IRR') {
          return `${this.formatPrice(Number(value || 0) / 10)} تومان`;
        }
        return this.formatCurrency(value);
      },
      reservedWithdrawalAmount(wallet) {
        const code = (typeof wallet === 'string' ? wallet : wallet?.currency_code || '').toUpperCase();
        const pendingDollar = Number(this.pendingWithdrawalBalances.USD || 0);
        if (code === 'USD') {
          const usdWallet = this.walletBalances.find(item => (item.currency_code || '').toUpperCase() === 'USD');
          const usdAvailable = Number(usdWallet?.available_balance ?? usdWallet?.balance ?? 0);
          return Math.min(pendingDollar, Math.max(usdAvailable, 0));
        }
        if (code === 'USDT') {
          const hasUsdWallet = this.walletBalances.some(item => (item.currency_code || '').toUpperCase() === 'USD');
          if (!hasUsdWallet) return pendingDollar;
          const usdWallet = this.walletBalances.find(item => (item.currency_code || '').toUpperCase() === 'USD');
          const usdAvailable = Number(usdWallet?.available_balance ?? usdWallet?.balance ?? 0);
          return Math.max(0, pendingDollar - Math.max(usdAvailable, 0));
        }
        return Number(this.pendingWithdrawalBalances[code] || 0);
      },
      displayAvailableBalance(wallet) {
        const available = Number(wallet.available_balance ?? wallet.balance ?? 0);
        return Math.max(0, available - this.reservedWithdrawalAmount(wallet));
      },
      async fetchWalletBalances() {
        try {
          const userData = localStorage.getItem('user');
          const user = userData ? JSON.parse(userData) : null;
          if (!user?.id) return;

          const response = await axios.post('/get-wallet-users', { user_id: user.id });
          if (response.data?.success && Array.isArray(response.data.data)) {
            this.walletBalances = response.data.data;
          } else if (Array.isArray(response.data)) {
            this.walletBalances = response.data;
          }
        } catch (error) {
          console.error('Failed to fetch withdrawal balances', error);
        }
      },
      async fetchPendingWithdrawals() {
        try {
          const userData = localStorage.getItem('user');
          const user = userData ? JSON.parse(userData) : null;
          if (!user?.id) return;

          const response = await axios.post('/withdraw-user', { user_id: user.id });
          const withdrawals = response.data?.[1]?.[0]?.data;
          if (!Array.isArray(withdrawals)) return;
          this.withdrawalRecords = withdrawals;

          this.pendingWithdrawalBalances = withdrawals.reduce((totals, withdrawal) => {
            if (Number(withdrawal.status) !== 2 || withdrawal.balance_deducted) return totals;
            const code = (withdrawal.currency || '').toUpperCase();
            const key = ['USD', 'USDT'].includes(code) ? 'USD' : code;
            totals[key] = (totals[key] || 0) + Number(withdrawal.total_debited || withdrawal.amount || 0);
            return totals;
          }, {});
        } catch (error) {
          console.error('Failed to fetch pending withdrawals', error);
        }
      },
      async fetchWithdrawalFee() {
        try {
          const userData = localStorage.getItem('user');
          const user = userData ? JSON.parse(userData) : null;
          if (!user?.id) return;

          const response = await axios.post('/referral-user-get', { id: user.id });
          const fee = Number(response.data?.current_level?.withdrawal_fee ?? 0);
          this.withdrawalFeePercent = Number.isFinite(fee) && fee >= 0 && fee <= 100 ? fee : 0;
        } catch (error) {
          console.error('Failed to fetch withdrawal fee for current referral level', error);
          this.withdrawalFeePercent = 0;
        }
      },
      setMaxAmount() {
        const selectedAccount = this.radios1 === 'dollar' ? this.value2 : this.value1;
        const dollarWallets = this.walletBalances.filter(wallet =>
          ['USD', 'USDT'].includes((wallet.currency_code || '').toUpperCase())
        );
        const available = this.radios1 === 'dollar' && dollarWallets.length
          ? dollarWallets.reduce((total, wallet) => total + this.displayAvailableBalance(wallet), 0)
          : Number(selectedAccount?.balance ?? 0);
        const feeMultiplier = 1 + (this.withdrawalFeePercent / 100);
        const maxRequested = feeMultiplier > 0 ? available / feeMultiplier : 0;
        this.moneyDollar = Number.isFinite(maxRequested) ? String(Math.floor(maxRequested * 1e8) / 1e8) : '0';
      },
      async fetchUSDT() {
        try {
          const response = await axios.get('https://apiv2.nobitex.ir/market/stats?srcCurrency=usdt&dstCurrency=rls', {
            timeout: 5000
          });
          const latestRialPrice = Number(response.data?.stats?.['usdt-rls']?.latest);
          if (response.data?.status !== 'ok' || !Number.isFinite(latestRialPrice) || latestRialPrice <= 0) {
            throw new Error('Invalid USDT/IRR price response from Nobitex');
          }
          this.usdtRate = latestRialPrice / 10;
        } catch (error) {
          console.error('Error fetching USDT price from Nobitex:', error);
        }
      },

      async btnClickSend(){
        const userData = localStorage.getItem('user');
        const userData1 = JSON.parse(userData);

        let typeD = 0;
        if (this.radios1 == 'rial') {
          typeD = 2;
        } else {
          typeD = 1;
        }

        // Validate required fields before sending request
        let errors = [];
        if (!this.moneyDollar || this.moneyDollar <= 0) {
          errors.push(this.$t('withdraw.errors.amountRequired'));
        }
        
        if (typeD === 1 && (!this.value2 || !this.value2.value)) {
          errors.push(this.$t('withdraw.errors.walletRequired'));
        }
        
        if (typeD === 2 && (!this.value1 || !this.value1.value)) {
          errors.push(this.$t('withdraw.errors.bankAccountRequired'));
        }
        
        // Show validation errors if any
        if (errors.length > 0) {
          errors.forEach(error => {
            toast(error, {
              autoClose: 3000,
              position: "top-right",
              type: "error",
            });
          });
          return;
        }

        let attempts = 0;
        const maxAttempts = 10;
        const delay = 100;
        while (attempts < maxAttempts) {
          try {
            const response = await axios.post('/withdraw-store' , {
              user_id : userData1.id,
              method_code : typeD,
              wallet_id : this.value2.value,
              bank_account_id : this.value1.value,
              amount : this.moneyDollar,
            });

            if(response.data?.success || response.data === 'success'){
              await Promise.all([this.getWallet(), this.fetchWalletBalances(), this.fetchPendingWithdrawals()]);

              toast("درخواست شما با موفقیت ثبت شد.", {
                autoClose: 3000,
                position: "top-right",
                type: "success",
              });
              // this.$router.push({ path: '/transaction' });
            }

            if(Array.isArray(response.data) && response.data[0] == "error"){
              toast(response.data[1], {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
            return;
          } catch (error) {
            if (error.response) {
              // خطاهای اعتبارسنجی را دریافت کنید
              const errors = error.response.data.errors;

              const keys = Object.keys(errors);
              for (const key of keys) {
                toast(errors[key].join(', '), {
                  autoClose: 3000,
                  position: "top-right",
                  type: "error",
                });
              }
              return;
            } else {
              console.error('An unexpected error occurred:', error.message);
              toast("یک خطای غیرمنتظره رخ داده است.", {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
          }

          attempts++;
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      }
    },
    mounted(){
      this.getWallet()
      this.fetchWalletBalances()
      this.fetchPendingWithdrawals()
      this.fetchWithdrawalFee()
      this.fetchUSDT()
      this.usdtRateTimer = setInterval(() => {
        this.fetchUSDT()
      }, 30000);
    },
    beforeUnmount() {
      if (this.usdtRateTimer) {
        clearInterval(this.usdtRateTimer);
        this.usdtRateTimer = null;
      }
    }
  }
</script>

<style scoped>
.withdraw-balance-summary {
  margin: 14px 16px 0;
}
</style>
  
  